import { generateQuery } from 'utils';
import http from 'utils/http';

export const getCampaigns = (params = {}) => {
  const query = generateQuery([
    params.search ? `search=${encodeURIComponent(params.search)}` : '',
    params.page > 1 ? `page=${params.page}` : '',
    params.page_size ? `page_size=${params.page_size}` : '',
    params.status ? `status=${params.status}` : '',
  ]);
  return http
    .get(`v1/organizations/{{organizationId}}/campaigns/${query}`)
    .then((res) => res.data);
};

export const getCampaign = (campaignId) =>
  http
    .get(`v1/organizations/{{organizationId}}/campaigns/${campaignId}/`)
    .then((res) => res.data);

export const createCampaign = (data) =>
  http
    .post('v1/organizations/{{organizationId}}/campaigns/', data)
    .then((res) => res.data);

export const updateCampaign = (campaignId, data) =>
  http
    .patch(`v1/organizations/{{organizationId}}/campaigns/${campaignId}/`, data)
    .then((res) => res.data);

export const deleteCampaign = (campaignId) =>
  http
    .delete(`v1/organizations/{{organizationId}}/campaigns/${campaignId}/`)
    .then((res) => res.data);

export const previewCampaignAudience = (data) =>
  http
    .post('v1/organizations/{{organizationId}}/campaigns/preview/', data)
    .then((res) => res.data);

export const sendCampaign = (campaignId) =>
  http
    .post(`v1/organizations/{{organizationId}}/campaigns/${campaignId}/send/`)
    .then((res) => res.data);

export const scheduleCampaign = (campaignId, sendAt) =>
  http
    .post(`v1/organizations/{{organizationId}}/campaigns/${campaignId}/schedule/`, {
      send_at: sendAt,
    })
    .then((res) => res.data);

export const unscheduleCampaign = (campaignId) =>
  http
    .post(`v1/organizations/{{organizationId}}/campaigns/${campaignId}/unschedule/`)
    .then((res) => res.data);

export const getCampaignRecipients = (campaignId, params = {}) => {
  const query = generateQuery([
    params.page > 1 ? `page=${params.page}` : '',
    params.page_size ? `page_size=${params.page_size}` : '',
  ]);
  return http
    .get(`v1/organizations/{{organizationId}}/campaigns/${campaignId}/recipients/${query}`)
    .then((res) => res.data);
};
